import { Form } from 'factorial-form'

class ExportYearlyBalanceForm extends Form {
  constructor(values: object = {}) {
    super(values, {
      start_date: 'string',
      end_date: 'string',
      teams_ids: 'any',
      locations_ids: 'any',
    })
  }
}

export default ExportYearlyBalanceForm
